import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { useStore } from 'vuex';
import { generateNewStyle, writeNewStyle } from '@/utils/theme';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
export default {
  __name: 'App',
  setup(__props) {
    const store = useStore();
    generateNewStyle(store.getters.mainColor).then(newStyleText => {
      writeNewStyle(newStyleText);
    });
    document.body.removeChild(document.querySelector('.app-loading'));

    // let beforeUnloadTime = 0
    // document.addEventListener('beforeUnload', () => {
    //   beforeUnloadTime = new Date().getTime()
    // })
    // // 监听网页关闭清除缓存
    // document.addEventListener('beforeunload', () => {
    //   console.log('用户刷新界面')
    // })

    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      const _component_el_config_provider = _resolveComponent("el-config-provider");
      return _openBlock(), _createBlock(_component_el_config_provider, {
        locale: _unref(zhCn)
      }, {
        default: _withCtx(() => [_createVNode(_component_router_view)]),
        _: 1
      }, 8, ["locale"]);
    };
  }
};